import { CustomError } from '../../common/errors';
import { Domains } from '../../constants';

export class DomainSettingsNotFoundError extends CustomError {
  constructor(readonly domain: Domains) {
    super(
      'DomainSettingsNotFoundError',
      `Couldn't find domain settings for domain ${domain}`
    );
  }
}

export class DomainSettingsFetchError extends CustomError {
  constructor(
    readonly domain: Domains,
    readonly error: Error
  ) {
    super(
      'DomainSettingsFetchError',
      `Couldn't fetch domain settings for domain ${domain}. Error: ${error.message}`
    );
  }
}

export class DomainSettingsUpdateError extends CustomError {
  constructor(
    readonly domain: Domains,
    readonly error: Error
  ) {
    super(
      'DomainSettingsFetchError',
      `Couldn't update domain settings for domain ${domain}. Error: ${error.message}`
    );
  }
}
